import { TarefasPage } from '@/pages/TarefasPage'

export function AdminTarefasPage() {
  return <TarefasPage />
}
